import React from 'react';
import { fmtDate } from '../../utils/dates';
import { Spinner } from '../common/Feedback';

const SOURCE_LABELS = {
  nyafaz: 'Nyafaz customer',
  demo_engagement: 'Demo Engagement',
  checkin: 'Branch check-in',
  pos: 'Past POS bill',
};

/** Everyone found for a phone number, across all sources — the cashier taps the right person. */
export default function CustomerMatches({ result, busyKey, onPick, onNewWalkIn }) {
  const { matches = [], searched = [], errors = {} } = result;
  return (
    <div className="dp-matches">
      <p className="dp-label">
        {matches.length ? `${matches.length} found for +91 ${result.phone}` : `No one found for +91 ${result.phone}`}
      </p>
      {matches.length ? (
        <div className="dp-match-list">
          {matches.map((m, i) => {
            const key = `${m.source}-${m.face_user_id || m.name}-${i}`;
            return (
              <button key={key} type="button" className="dp-match" onClick={() => onPick(m, key)} disabled={Boolean(busyKey)}>
                <span className="dp-avatar">{(m.name || 'G').trim().charAt(0).toUpperCase()}</span>
                <span className="dp-match-main">
                  <strong>{m.name}</strong>
                  <small>
                    {[m.detail, m.last_seen ? fmtDate(m.last_seen) : null].filter(Boolean).join(' · ')}
                  </small>
                </span>
                {m.tier ? <span className="dp-pill dp-pill--gold">{m.tier}</span> : null}
                <span className={`dp-source dp-source--${m.source === 'demo_engagement' ? 'engagement' : 'checkin'}`}>
                  {SOURCE_LABELS[m.source] || m.source}
                </span>
                {busyKey === key ? <Spinner small /> : null}
              </button>
            );
          })}
        </div>
      ) : null}
      <p className="dp-help dp-match-foot">
        Searched: {searched.join(', ')}.{' '}
        {Object.values(errors).length ? <span className="dp-warn-text">{Object.values(errors).join(' ')}</span> : null}
      </p>
      <button type="button" className="dp-btn dp-btn--ghost" onClick={onNewWalkIn} disabled={Boolean(busyKey)}>
        {matches.length ? 'Someone else — new walk-in' : 'Bill as a new walk-in'}
      </button>
    </div>
  );
}
